import { Component, ChangeDetectionStrategy, ViewChild, Input, Inject } from '@angular/core';
import { Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { createFormControl } from 'osn-shared';
import { PageType } from '../../../page-edit-screen/page-type';
import { ConfirmDialogViewModel, defaultConfirmDialogViewModelValues } from '../confirm-dialog/confirm-dialog.view-model';
import { DialogComponent } from '../dialog/dialog.component';

@Component({
  selector: 'osn-cxb-tray-cloning-dialog',
  templateUrl: './tray-cloning-dialog.component.html',
  styleUrls: ['./tray-cloning-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrayCloningDialogComponent {
  @Input() public confirmDisabled = false;
  @ViewChild(DialogComponent) private readonly dialog: DialogComponent;

  public readonly targetPageControl = createFormControl('', Validators.required);
  public readonly isGenrePage = this.data.pageType === PageType.genre;

  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmDialogViewModel) {
    this.data = { ...defaultConfirmDialogViewModelValues, ...data };
  }

  public cloneTray(): void {
    return this.dialog.closeDialog(this.targetPageControl.value);
  }

  public closeDialog(): void {
    this.dialog.closeDialog();
  }
}
